export class ContactUsData {
    brandName: string;
    firstName: string;
    lastName: string;
    contactNumber: string;
    emailAddress: string;
    message: string;
    captchaResponse: string;
}
